import React from "react";

const NotFound = () => <h1>404 NOT FOUND</h1>;

export default NotFound;
